module.exports = __webpack_public_path__ + "static/media/user-logo.c4d49a4e.jpg";